// Gedeelde telefoonvalidatie voor alle formulieren (JOH. huisstijl: NL meldingen).
// Accepteert o.a. "+31 6 12345678", "+31612345678", "06 12345678". Weigert letters en te korte nummers.
export function validatePhone(phone, { required = false } = {}) {
  const p = (phone || "").trim();
  if (!p) return required ? "Telefoonnummer is verplicht" : "";
  if (/[a-zA-Z]/.test(p)) return "Telefoonnummer mag geen letters bevatten";
  const cleaned = p.replace(/[\s\-()]/g, "");
  if (!/^\+?\d+$/.test(cleaned)) return "Ongeldig telefoonnummer — gebruik bijv. +31 6 12345678";
  const digits = cleaned.replace(/\D/g, "");
  if (digits.length < 9) return "Telefoonnummer is te kort — gebruik bijv. +31 6 12345678";
  if (cleaned.startsWith("+")) {
    if (digits.length < 10) return "Telefoonnummer met landcode is te kort — gebruik bijv. +31 6 12345678";
  } else if (!cleaned.startsWith("0")) {
    return "Voeg een landcode toe, bijv. +31 6 12345678";
  }
  return "";
}
